<template>
  <div v-if="student">

      <b-container class="main-container">
        <b-row>
          <b-col sm="12">
          <h3>{{ student.firstName + " " + student.lastName}}
            <b-button style="float:right" class="ml-2" variant="primary" :to="{ name: 'impersonation', params: { asuriteId: student.asuriteId } }">View as Student</b-button> 
          </h3>
          
          </b-col>
        </b-row>
        
        <b-row>
            <b-col sm="12">                
              <widget heading="Student Information">
                <student-details :student="student"></student-details>
              </widget>

              <widget heading="Opportunities">
                <student-opportunities :opportunities="opportunities"></student-opportunities>
              </widget>

              <!-- student details -->
              <widget heading="Notes">
                <student-notes :notes="notes" :asuriteId="student.asuriteId"></student-notes>
              </widget>
            </b-col>
        </b-row>
      </b-container>  
  </div>
</template>

<script>
import StudentDetails from "../../components/students/student-details";
import StudentOpportunities from "../../components/students/student-opportunities";
import StudentNotes from "../../components/students/student-notes";
import Widget from "../../components/widget";
import studentApi from "../../api/student";
import { mapState } from "vuex";

export default {
  data() {
    return {
      student: {},
      opportunities: [],
      notes: []
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  props: {
    id: {
      required: true
    }
  },

  components: {
    "student-details": StudentDetails,
    "student-opportunities": StudentOpportunities,
    "student-notes": StudentNotes,
    widget: Widget
  },

  methods: {},

  created() {
    var that = this;
    studentApi
      .getStudentInformation(this.id)
      .then(function(response) {
        that.student = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    studentApi
      .getOpportunitiesForStudent(this.id)
      .then(function(response) {
        that.opportunities = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    studentApi
      .getStudentNotes(this.id)
      .then(function(response) {
        that.notes = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
label {
  font-weight: bold;
}

p {
  margin-bottom: 0.3em;
}

.student-details {
  padding: 15px 5px 10px 5px;
}

.main-container {
  max-width: 100%;
  margin-top: 10px;
}

.widget-body {
  max-width: 100%;
}
</style>
